module.exports = __webpack_public_path__ + "img/PackStage.94d6dd72.svg";